import React, { Component } from 'react'
import { computeScores } from './Scores'
import { FiUser, FiUsers, FiActivity, FiRewind } from 'react-icons/fi'

//
// 2022: Check
// Pete Roberts - Behind the Footy
//
// https://www.behindthefooty.com.au/
//
// Max Laughton -
// https://www.foxsports.com.au/afl/afl-news-2022-season-preview-predicted-ladder-stats-analysis-rules-for-picking-top-eight-historic-results-who-misses-finals/news-story/a783b15321ac83793b7b2798ec212cd2
//
// https://www.statsinsider.com.au/afl/futures
//
// Tom Morris
// https://www.foxsports.com.au/afl/afl-news-2022-tom-morris-predicted-ladder-every-club-ranked-analysis-season-preview-top-eight-finals/news-story/e8fe4d752022dac6cbda2e348c4ddf98?recommendedCount=0
//
// Adrian (the Roar)
// https://fromthetopdeck.com.au/f/predicting-the-unpredictable
//
const experts = {
		2026: [
		{
			name: '2025',
			org: 'Previous year\'s ladder',
			data: '2026agbdifhjrpcomkelnq',
			url: 'https://afltables.com/afl/seas/2025.html',
			type: 'history',
		},
		{
			name: '2025 + Finals',
			org: 'Standings after finals',
			data: '2026bgadjhifrpcomkelnq',
			url: 'https://afltables.com/afl/seas/2025.html',
			type: 'history',
		},
		{
			name: 'Jake Niall',
			org: 'The Age',
			data: '2026bpghfjaordiceklmnq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Michael Gleeson',
			org: 'The Age',
			data: '2026hbpfgjardiocknmelq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Peter Ryan',
			org: 'The Age',
			data: '2026hbfpgjdroiaeclmnkq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Jon Pierik',
			org: 'The Age',
			data: '2026bhpgjarfodcimelknq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Andrew Wu',
			org: 'The Age',
			data: '2026bpgrfjhaidcokemlnq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Sam McClure',
			org: 'The Age',
			data: '2026phbafgojridcemlknq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Caroline Wilson',
			org: 'The Age',
			data: '2026bijhpgfaroecdmkqnl',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Emma Kearney',
			org: 'The Age',
			data: '2026bjgrhadfpoimlckenq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Libby Birch',
			org: 'The Age',
			data: '2026baghjfopridlckmneq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Matthew Stokes',
			org: 'The Age',
			data: '2026hbprgajfiocdlemknq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Scott Spits',
			org: 'The Age',
			data: '2026bajhpfgidrkocelmqn',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Mark McGowan',
			org: 'The Age',
			data: '2026bahpgfjdriolckmenq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Wayne Campbell',
			org: 'The Age',
			data: '2026ahpbjfrgidecklnomq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Jimmy Bartel',
			org: 'The Age',
			data: '2026fhbarjgpdoiecklnmq',
			url: 'https://www.theage.com.au/sport/afl/brisbane-are-strong-flag-favourites-but-could-sydney-come-from-the-clouds-20260228-p5o68u.html',
		},
		{
			name: 'Max Laughton',
			org: 'Fox Sports',
			data: '2026bghrpjafdoimceklnq',
			url: 'https://www.foxsports.com.au/afl/afl-predicted-ladder-2026-preseason-analysis-season-preview-who-will-play-finals-tips-for-premiership-and-top-10/news-story/023ed8532ed6491d5049b209f03078bd',
		},
		{
			name: 'Jonathan Horn',
			org: 'The Guardian',
			data: '2026bphfjarigockdmleqn',
			url: 'https://www.theguardian.com/sport/blog/2026/mar/02/afl-ladder-predictor-2026-predictions-geelong-cats',
		},
		{
			name: 'Damian Barrett',
			org: 'AFL Media',
			data: '2026fgbdphjacrmoikelnq',
			url: 'https://www.afl.com.au/news/1471518/expert-predictions-for-2026-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Gemma Bastiani',
			org: 'AFL Media',
			data: '2026brphgokcafijmdenlq',
			url: 'https://www.afl.com.au/news/1471518/expert-predictions-for-2026-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Riley Beveridge',
			org: 'AFL Media',
			data: '2026brfhjgapdicmoelknq',
			url: 'https://www.afl.com.au/news/1471518/expert-predictions-for-2026-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Sarah Black',
			org: 'AFL Media',
			data: '2026bhapfjirgdcoekmlnq',
			url: 'https://www.afl.com.au/news/1471518/expert-predictions-for-2026-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Nat Edwards',
			org: 'AFL Media',
			data: '2026bfgphajrodickmelnq',
			url: 'https://www.afl.com.au/news/1471518/expert-predictions-for-2026-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Josh Gabelich',
			org: 'AFL Media',
			data: '2026bfphjagroidmkclneq',
			url: 'https://www.afl.com.au/news/1471518/expert-predictions-for-2026-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Nathan Schmook',
			org: 'AFL Media',
			data: '2026bfghprajmodiceklnq',
			url: 'https://www.afl.com.au/news/1471518/expert-predictions-for-2026-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Callum Twomey',
			org: 'AFL Media',
			data: '2026bphrfgojadickmelnq',
			url: 'https://www.afl.com.au/news/1471518/expert-predictions-for-2026-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Michael Whiting',
			org: 'AFL Media',
			data: '2026bfphgrajiodlkcmenq',
			url: 'https://www.afl.com.au/news/1471518/expert-predictions-for-2026-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Dwayne Russell',
			org: 'SEN',
			data: '2026bpfrgjaiodhmcklenq',
			url: 'https://www.sen.com.au/news/2026/03/03/afl-2026-dwayne-russells-ladder-prediction-sen-dwaynes-world',
		},
		{
			name: 'Jon Anderson',
			org: 'SEN',
			data: '2026hbpjfarogdickenmlq',
			url: 'https://www.3aw.com.au/jon-anderson-predicts-where-all-18-teams-will-finish-on-the-afl-ladder/',
		},
		{
			name: 'Jake Michaels',
			org: 'ESPN',
			data: '2026bjirafghdopmkclenq',
			url: 'https://www.espn.com.au/afl/story/_/id/46351758/afl-2026-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Rohan Connolly',
			org: 'ESPN',
			data: '2026bgahpjdfrickomlenq',
			url: 'https://x.com/rohan_connolly/status/2029408457909256565',
		},
		{
			name: 'Matt Walsh',
			org: 'ESPN',
			data: '2026bhjfagoripckdlmneq',
			url: 'https://www.espn.com.au/afl/story/_/id/46351758/afl-2026-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Jarryd Barca',
			org: 'ESPN',
			data: '2026bfjhiroapmdgcklenq',
			url: 'https://www.espn.com.au/afl/story/_/id/46351758/afl-2026-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Christian Joly',
			org: 'ESPN/Champion Data',
			data: '2026jbhfgraipdocemlknq',
			url: 'https://www.espn.com.au/afl/story/_/id/46351758/afl-2026-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'AFL.com.au',
			org: 'AFL Media',
			data: '2026bfphgrajoidcmkelnq',
			url: 'https://www.afl.com.au/news/1471832/our-predicted-ladder-no-love-for-pies-non-victorian-clubs-dominate',
			type: 'crowd',
		},
		{
			name: 'Squiggle',
			org: 'squiggle.com.au',
			data: '2026bgrjadchfipomeklqn',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'Matter of Stats',
			org: 'matterofstats.com',
			data: '2026bgrjdiahfpkcmolneq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'plusSixOne',
			org: 'plussixoneblog.com',
			data: '2026bgajifdrphmocklneq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'GRAFT Ratings',
			org: 'graftratings.com',
			data: '2026garjdbhifpkcmoelnq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'Stattraction',
			org: 'stattraction.com',
			data: '2026brgjadhfikpcomlenq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'Live Ladders',
			org: 'liveladders.com',
			data: '2026gbjdraihfkpocmnleq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'AFLalytics',
			org: 'aflalytics.com',
			data: '2026gbrjdhaifkpcmolneq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'AFL Lab',
			org: 'theafllab.com',
			data: '2026gbrjdiakfhpocmlenq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'Glicko Ratings',
			org: 'aflglickoratings.blogspot.com',
			data: '2026brgjihdfapcokmelnq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'ZaphBot',
			org: 'zaphbot.blogspot.com',
			data: '2026grbjaidhfpkocmleqn',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'Wheelo Ratings',
			org: 'wheeloratings.com',
			data: '2026gbrjadihfkpcomlneq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'The Footycast',
			org: 'thefootycast.com',
			data: '2026bgjriadfhkpcmolenq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'Elo Predicts!',
			org: 'elopredicts.blogspot.com',
			data: '2026bgirajdhpfmkcoenlq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: "Don't Blame the Data",
			org: 'dontblamethedata.com',
			data: '2026gbrdjhaifpkcomlenq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'What Snoo Thinks',
			org: 'whatsnoothinks.blogspot.com',
			data: '2026rgajdbhkifponclmeq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},
		{
			name: 'Winnable',
			org: 'winnableafl.com',
			data: '2026bgrajhfdpcioklmneq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2026',
			type: 'model',
		},

	],

	2025: [
		{
			name: '2024',
			org: 'Previous year\'s ladder',
			data: '2025pmgibrjcdfeohkaqln',
			url: 'https://afltables.com/afl/seas/2024.html',
			type: 'history',
		},
		{
			name: '2024 + Finals',
			org: 'Standings after finals',
			data: '2025bpmgijrcdfeohkaqln',
			url: 'https://afltables.com/afl/seas/2024.html',
			type: 'history',
		},
		{
			name: 'Max Laughton',
			org: 'Fox Sports',
			data: '2025jbfgdprhicamkeolqn',
			url: 'https://www.foxsports.com.au/afl/afl-predicted-ladder-2025-preseason-analysis-and-preview-tips-for-premiership-top-eight-and-wooden-spoon-rules-to-pick-the-ladder/news-story/c8a5d5014097e261b88dd08514b5e367',
		},
		{
			name: 'Jake Michaels',
			org: 'ESPN',
			data: '2025jbpicmgrfdheoakqln',
			url: 'https://www.espn.com.au/afl/story/_/id/41391638/afl-2025-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Matt Walsh',
			org: 'ESPN',
			data: '2025cbifmrpojgkahdleqn',
			url: 'https://www.espn.com.au/afl/story/_/id/41391638/afl-2025-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'SEN Fan Survey',
			org: 'SEN',
			data: '2025bcpigjdfmrhakoelnq',
			url: 'https://sen.com.au/news/2024/12/17/fans-pick-the-top-8-and-full-ladder-for-the-2025-afl-season',
			type: 'crowd',
		},
		{
			name: 'Jake Niall',
			org: 'The Age',
			data: '2025bijfpkcgdahmroelqn',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Michael Gleeson',
			org: 'The Age',
			data: '2025igdcbpfkhjmraoelqn',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Peter Ryan',
			org: 'The Age',
			data: '2025ibpfgrdjchkamoleqn',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Jon Pierik',
			org: 'The Age',
			data: '2025bicfjrpgdhmeklaqon',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Andrew Wu',
			org: 'The Age',
			data: '2025pgicfkjbdahrmeolqn',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Marc McGowan',
			org: 'The Age',
			data: '2025gbifcpjdkhmareloqn',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Sam McClure',
			org: 'The Age',
			data: '2025ipgcbfjhdmkoareqln',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Caroline Wilson',
			org: 'The Age',
			data: '2025bipkjcgdfmhealqron',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Emma Kearney',
			org: 'The Age',
			data: '2025dbgjcirpmhaklfeoqn',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Libby Birch',
			org: 'The Age',
			data: '2025jibpcfgdrhalkemoqn',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Bob Murphy',
			org: 'The Age',
			data: '2025ibgfdprhjmkaceolqn',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Matthew Stokes',
			org: 'The Age',
			data: '2025ipgbcdjhfrmekoalqn',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Scott Spits',
			org: 'The Age',
			data: '2025ibpgjckfdmrealhqon',
			url: 'https://www.smh.com.au/sport/afl/winless-tigers-hawks-on-the-rise-our-experts-predict-season-2025-20250206-p5la7d.html',
		},
		{
			name: 'Cody Atkinson and Sean Lawson',
			org: 'ABC',
			data: '2025prbjgficmdakhoenql',
			url: 'https://www.abc.net.au/news/2025-03-06/unpredictable-afl-season-2025-set-to-be-most-open-in-years/105011528',
		},
		{
			name: 'Damian Barrett',
			org: 'AFL Media',
			data: '2025gfibpdcjkamhreoqln',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Gemma Bastiani',
			org: 'AFL Media',
			data: '2025jbdpgfmhikrcaeloqn',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Riley Beveridge',
			org: 'AFL Media',
			data: '2025bfpijdcmgkhraelqon',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Sarah Black',
			org: 'AFL Media',
			data: '2025ibpdjcgfamkrehoqln',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Nat Edwards',
			org: 'AFL Media',
			data: '2025bcdfpijgahmerkolqn',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Josh Gabelich',
			org: 'AFL Media',
			data: '2025idgfbjpkchrmaeolqn',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Sarah Olle',
			org: 'AFL Media',
			data: '2025gibfpjdchamrkeloqn',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Nathan Schmook',
			org: 'AFL Media',
			data: '2025bifgpjadchmkerloqn',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Callum Twomey',
			org: 'AFL Media',
			data: '2025dbgipckjafmherloqn',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Michael Whiting',
			org: 'AFL Media',
			data: '2025bifgjpadhrckmeloqn',
			url: 'https://www.afl.com.au/news/1274339/expert-predictions-for-2025-aflcomaus-premiers-wooden-spooners-brownlow-medal-winner-rising-star-and-more',
		},
		{
			name: 'Squiggle',
			org: 'squiggle.com.au',
			data: '2025bjgrfcadmkpihoeqln',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'Matter of Stats',
			org: 'matterofstats.com',
			data: '2025brjgmpfcaidkohenql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'plusSixOne',
			org: 'plussixoneblog.com',
			data: '2025bprgcjfkmdiaoehnql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'GRAFT Ratings',
			org: 'graftratings.com',
			data: '2025prbmgifkacjdhoenql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'Stattraction',
			org: 'stattraction.com',
			data: '2025brjpgmfciadoekhnql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'Live Ladders',
			org: 'liveladders.com',
			data: '2025jbrgmifodphcakeqnl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'AFLalytics',
			org: 'aflalytics.com',
			data: '2025brjgpmficadkohenql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'AFL Lab',
			org: 'theafllab.com',
			data: '2025grbjmpdoaichekfnql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'Glicko Ratings',
			org: 'aflglickoratings.blogspot.com',
			data: '2025bjrgcpfiadhemkoqln',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'ZaphBot',
			org: 'zaphbot.blogspot.com',
			data: '2025bjpgrmifcodhkealqn',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'Wheelo Ratings',
			org: 'wheeloratings.com',
			data: '2025bjrgpifcadomkhenql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'The Footycast',
			org: 'thefootycast.com',
			data: '2025pbjrgcifmadokheqnl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'Elo Predicts!',
			org: 'elopredicts.blogspot.com',
			data: '2025bprgjcifkmdaohenql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: "Don't Blame the Data",
			org: 'dontblamethedata.com',
			data: '2025brjgpmdfciahoeknql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'What Snoo Thinks',
			org: 'whatsnoothinks.blogspot.com',
			data: '2025rbjgpcfimdaoheknql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'Winnable',
			org: 'winnableafl.com',
			data: '2025jbrfdgcpamkhoielqn',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2025',
			type: 'model',
		},
		{
			name: 'Johnathan Horn',
			org: 'The Guardian',
			data: '2025dbkpimfjgaerochlqn',
			url: 'https://www.theguardian.com/sport/2025/mar/05/afl-season-2025-ladder-predictor-part-two',
		},
	],
	2024: [
		{
			name: '2023',
			org: 'Previous year\'s ladder',
			data: '2024dbmkcoipraegnfhjlq',
			url: 'https://afltables.com/afl/seas/2023.html',
			type: 'history',
		},
		{
			name: '2023 + Finals',
			org: 'Standings after finals',
			data: '2024dbcimkopraegnfhjlq',
			url: 'https://afltables.com/afl/seas/2023.html',
			type: 'history',
		},
		{
			name: 'Max Laughton',
			org: 'Fox Sports',
			data: '2024bidakomgpcrhfenjlq',
			url: 'https://www.foxsports.com.au/afl/afl-predicted-ladder-2024-preseason-analysis-and-preview-tips-for-top-four-top-eight-and-wooden-spoon-latest-news/news-story/61bdfb9530df4231aeaaff1bf661c5c0',
		},
		{
			name: 'Damian Barrett',
			org: 'AFL Media',
			data: '2024bgpidckaofmrehnqlj',
			url: 'https://www.afl.com.au/news/1080056/crystal-ball-our-predictions-for-the-2024-afl-season-are-in',
		},
		{
			name: 'Riley Beveridge',
			org: 'AFL Media',
			data: '2024bdcikmaphrgoenfljq',
			url: 'https://www.afl.com.au/news/1080056/crystal-ball-our-predictions-for-the-2024-afl-season-are-in',
		},
		{
			name: 'Sarah Black',
			org: 'AFL Media',
			data: '2024bdpickmaogfrhenqjl',
			url: 'https://www.afl.com.au/news/1080056/crystal-ball-our-predictions-for-the-2024-afl-season-are-in',
		},
		{
			name: 'Nat Edwards',
			org: 'AFL Media',
			data: '2024bcdmikaeprghofnjlq',
			url: 'https://www.afl.com.au/news/1080056/crystal-ball-our-predictions-for-the-2024-afl-season-are-in',
		},
		{
			name: 'Josh Gabelich',
			org: 'AFL Media',
			data: '2024bdcipmrakhofgenjlq',
			url: 'https://www.afl.com.au/news/1080056/crystal-ball-our-predictions-for-the-2024-afl-season-are-in',
		},
		{
			name: 'Sarah Olle',
			org: 'AFL Media',
			data: '2024bidmckaphgroefnjlq',
			url: 'https://www.afl.com.au/news/1080056/crystal-ball-our-predictions-for-the-2024-afl-season-are-in',
		},
		{
			name: 'Nathan Schmook',
			org: 'AFL Media',
			data: '2024bidpcfamorkhgejnlq',
			url: 'https://www.afl.com.au/news/1080056/crystal-ball-our-predictions-for-the-2024-afl-season-are-in',
		},
		{
			name: 'Callum Twomey',
			org: 'AFL Media',
			data: '2024bmdkicprheaofgnljq',
			url: 'https://www.afl.com.au/news/1080056/crystal-ball-our-predictions-for-the-2024-afl-season-are-in',
		},
		{
			name: 'Michael Whiting',
			org: 'AFL Media',
			data: '2024bipdckahmfregonjlq',
			url: 'https://www.afl.com.au/news/1080056/crystal-ball-our-predictions-for-the-2024-afl-season-are-in',
		},
		{
			name: 'Jonathan Horn',
			org: 'The Guardian',
			data: '2024idmofkbcgrahpenjlq',
			url: 'https://www.theguardian.com/sport/2024/mar/05/afl-2024-predicted-ladder-part-two-collingwood-can-win-if-theyre-giant-killers',
		},
		{
			name: 'Jake Niall',
			org: 'The Age',
			data: '2024bipcdakhorgmfenljq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Michael Gleeson',
			org: 'The Age',
			data: '2024idbcpmkhageronfjlq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Peter Ryan',
			org: 'The Age',
			data: '2024bidckrogpahfmenljq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Jon Pierik',
			org: 'The Age',
			data: '2024bdpckirhgoamefnjlq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Andrew Wu',
			org: 'The Age',
			data: '2024bdkcipgaohrmfenjlq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Greg Baum',
			org: 'The Age',
			data: '2024cibdokmrapehjnglfq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Marc McGowan',
			org: 'The Age',
			data: '2024bidcpmkoaherfgnjlq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Sam McClure',
			org: 'The Age',
			data: '2024mcbdhpakgijfroenlq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Caroline Wilson',
			org: 'The Age',
			data: '2024cbiadkhmnoprgejflq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Emma Kearney',
			org: 'The Age',
			data: '2024dibrkcmhapgolfenjq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Libby Birch',
			org: 'The Age',
			data: '2024bdcipakromehglnfjq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Kane Cornes',
			org: 'The Age',
			data: '2024bpdcakihmgrfelnojq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Mathew Stokes',
			org: 'The Age',
			data: '2024idbgcphokmeralnjfq',
			url: 'https://www.theage.com.au/sport/afl/hungrier-than-ever-our-experts-preview-the-afl-season-20240226-p5f7vh.html',
		},
		{
			name: 'Mark Robinson',
			org: 'Herald-Sun',
			data: '2024bidmcpkoahegrjfnlq',
			url: 'https://www.heraldsun.com.au/sport/afl/afl-2024-mark-robinson-predicts-how-ladder-will-look-after-round-24/news-story/2e1a2cb01de1a5c2f58c8d4c02c25291',
		},
		{
			name: 'Mitch Keating',
			org: 'Zero Hanger',
			data: '2024bckidpmaogrhnjeflq',
			url: 'https://www.zerohanger.com/narrow-race-outside-of-top-eight-as-one-finals-team-falls-2024-afl-ladder-prediction-147909/',
		},
		{
			name: 'Matthew Lloyd',
			org: 'SEN',
			data: '2024bidkcpomrahegfnjlq',
			url: 'https://www.3aw.com.au/matthew-lloyd-reveals-his-full-ladder-prediction-ahead-of-the-2024-season/',
		},
		{
			name: 'Josh Jenkins',
			org: 'SEN',
			data: '2024bcdapgihmekrofnljq',
			url: 'https://www.sen.com.au/news/2024/01/25/josh-jenkins-extended-2024-ladder-prediction-6-to-1/',
		},
		{
			name: '2023 + Pythagorus',
			org: 'Fox Sports',
			data: '2024dkbacmgproifnhejlq',
			url: 'https://www.heraldsun.com.au/sport/afl/afl-predicted-ladder-where-your-club-could-sit-after-first-six-rounds-of-2024/news-story/1ed386a849af286365612653e9b0a256',
		},
		{
			name: 'Jake Michaels',
			org: 'ESPN',
			data: '2024bcdikamprhgojfnelq',
			url: 'https://www.espn.com.au/afl/story/_/id/38486785/afl-2024-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal-carlton-brisbane-collingwood',
		},
		{
			name: 'Rohan Connolly',
			org: 'ESPN',
			data: '2024bkcdajimrphnogeflq',
			url: 'https://www.espn.com.au/afl/story/_/id/38486785/afl-2024-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal-carlton-brisbane-collingwood',
		},
		{
			name: 'Matt Walsh',
			org: 'ESPN',
			data: '2024bcdkimpharjegfnolq',
			url: 'https://www.espn.com.au/afl/story/_/id/38486785/afl-2024-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal-carlton-brisbane-collingwood',
		},
		{
			name: 'Jarryd Barca',
			org: 'ESPN',
			data: '2024kcmbipdraehfgojnlq',
			url: 'https://www.espn.com.au/afl/story/_/id/38486785/afl-2024-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal-carlton-brisbane-collingwood',
		},
		{
			name: 'Squiggle',
			org: 'squiggle.com.au',
			data: '2024kibagmrdfcpohjnelq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'Matter of Stats',
			org: 'matterofstats.com',
			data: '2024iakbpdmfcorghnjleq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'plusSixOne',
			org: 'plussixoneblog.com',
			data: '2024kbdgpcmaorinfehjlq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'Stattraction',
			org: 'stattraction.com',
			data: '2024bkdigmacrpfohnjelq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'Live Ladders',
			org: 'liveladders.com',
			data: '2024imkabdgpofcrhnejlq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'AFLalytics',
			org: 'aflalytics.com',
			data: '2024ibakdmpgrfcohnjelq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'AFL Lab',
			org: 'theafllab.com',
			data: '2024kambigdpcrfnohejlq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'Glicko Ratings',
			org: 'aflglickoratings.blogspot.com',
			data: '2024ikbaprmdcngeofhjlq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'ZaphBot',
			org: 'zaphbot.blogspot.com',
			data: '2024dkmbargicphofnjelq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'Wheelo Ratings',
			org: 'wheeloratings.com',
			data: '2024ibkadpmgfcrohnjelq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'The Footycast',
			org: 'thefootycast.com',
			data: '2024bdkmacigrpofhnejlq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'Elo Predicts!',
			org: 'elopredicts.blogspot.com',
			data: '2024bkdipgcrmaohfnejlq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: "Don't Blame the Data",
			org: 'dontblamethedata.com',
			data: '2024kbdargmpicnohefjql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'What Snoo Thinks',
			org: 'whatsnoothinks.blogspot.com',
			data: '2024iakbmdpcfrogjhnelq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
		{
			name: 'Winnable',
			org: 'winnableafl.com',
			data: '2024iadbpkmgcrfohjnelq',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2024',
			type: 'model',
		},
	],
	2023: [
		{
			name: '2022',
			org: 'Previous year\'s ladder',
			data: '2023gkpdfbnrcomhjaeiql',
			url: 'https://afltables.com/afl/seas/2022.html',
			type: 'history',
		},
		{
			name: '2022 + Finals',
			org: 'Standings after finals',
			data: '2023gpdbkfnrcomhjaeiql',
			url: 'https://afltables.com/afl/seas/2022.html',
			type: 'history',
		},
		{
			name: 'Frank Seal',
			org: 'Zero Hanger',
			data: '2023kbgcpfdnmrhoealqji',
			url: 'https://www.zerohanger.com/predicting-the-2023-afl-ladder-132104/',
		},
		{
			name: '2022 + Pythagorus',
			org: 'Fox Sports',
			data: '2023gkpnbfmrcdhojaieql',
			url: 'https://www.foxsports.com.au/afl/afl-2023-season-preview-pythagorean-wins-analysis-luckiest-and-unluckiest-teams-in-2022-predicted-ladder-risers-and-fallers-stats/news-story/bea0e7710de188974c040c4ac4fda69d',
		},
		{
			name: 'Max Laughton',
			org: 'Fox Sports',
			data: '2023gkbcnpmfdrhaoqielj',
			url: 'https://www.foxsports.com.au/afl/blues-make-the-leap-power-surge-and-the-magpies-miss-full-predicted-23-afl-ladder/news-story/91ee037e7322fd79ebca8715bc494980',
		},
		{
			name: 'Jake Michaels',
			org: 'ESPN',
			data: '2023kgpmcbndfhroaeijlq',
			url: 'https://www.espn.com.au/afl/story/_/id/34652969/afl-2023-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Rohan Connolly',
			org: 'ESPN',
			data: '2023pdgkcbfnjramoheilq',
			url: 'https://www.espn.com.au/afl/story/_/id/34652969/afl-2023-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Matt Walsh',
			org: 'ESPN',
			data: '2023kcmndpbhrgfjoaeilq',
			url: 'https://www.espn.com.au/afl/story/_/id/34652969/afl-2023-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Jarryd Barca',
			org: 'ESPN',
			data: '2023krcpdbnmhgfeoajilq',
			url: 'https://www.espn.com.au/afl/story/_/id/34652969/afl-2023-espn-way-too-early-predictions-next-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Punters',
			org: 'Betting odds',
			data: '2023gkbnpcdfrmhaoeiqjl',
			url: '',
			type: 'crowd',
		},
		{
			name: 'Adrian Polykandrites',
			org: 'From the Top Deck',
			data: '2023bgkncprmfdihqaoelj',
			url: 'https://fromthetopdeck.com.au/f/more-pointless-predictions',
		},
		{
			name: 'Jake Niall',
			org: 'The Age',
			data: '2023kbgrcpdnfmihoqaelj',
			url: 'https://www.theage.com.au/sport/afl/they-ll-scare-the-hell-out-of-sides-why-jake-niall-says-the-blues-could-steal-a-grand-final-spot-20230310-p5cqzy.html',
		},
		{
			name: 'Caroline Wilson',
			org: 'The Age',
			data: '2023knbgcpimrdfhaoqejl',
			url: 'https://www.theage.com.au/sport/afl/why-i-m-tipping-collingwood-to-miss-the-eight-caroline-wilson-s-afl-season-crystal-ball-20230310-p5cqzw.html',
		},
		{
			name: 'Kane Cornes',
			org: 'The Age',
			data: '2023gbkrpfdacnmiheojql',
			url: 'https://www.theage.com.au/sport/afl/bad-to-disaster-kane-cornes-afl-crystal-ball-spells-doom-for-ross-lyon-s-st-kilda-20230310-p5cr03.html',
		},
		{
			name: 'Michael Gleeson',
			org: 'The Age',
			data: '2023knbgdrcphfmeioalqj',
			url: 'https://www.theage.com.au/sport/afl/this-is-his-year-our-experts-preview-the-afl-season-20230206-p5cibc.html',
		},
		{
			name: 'Peter Ryan',
			org: 'The Age',
			data: '2023bgnpkdrhfcmioeqalj',
			url: 'https://www.theage.com.au/sport/afl/this-is-his-year-our-experts-preview-the-afl-season-20230206-p5cibc.html',
		},
		{
			name: 'Jon Pierik',
			org: 'The Age',
			data: '2023bgkpdcnmrhoefaiqjl',
			url: 'https://www.theage.com.au/sport/afl/this-is-his-year-our-experts-preview-the-afl-season-20230206-p5cibc.html',
		},
		{
			name: 'Andrew Wu',
			org: 'The Age',
			data: '2023kgbpcfdirnahmoqelj',
			url: 'https://www.theage.com.au/sport/afl/this-is-his-year-our-experts-preview-the-afl-season-20230206-p5cibc.html',
		},
		{
			name: 'Greg Baum',
			org: 'The Age',
			data: '2023bgckrndhpfmqeaolij',
			url: 'https://www.theage.com.au/sport/afl/this-is-his-year-our-experts-preview-the-afl-season-20230206-p5cibc.html',
		},
		{
			name: 'Marc McGowan',
			org: 'The Age',
			data: '2023kbgcprhndfmaeloijq',
			url: 'https://www.theage.com.au/sport/afl/this-is-his-year-our-experts-preview-the-afl-season-20230206-p5cibc.html',
		},
		{
			name: 'Emma Kearney',
			org: 'The Age',
			data: '2023kbcgdprnmfhiaeloqj',
			url: 'https://www.theage.com.au/sport/afl/this-is-his-year-our-experts-preview-the-afl-season-20230206-p5cibc.html',
		},
		{
			name: 'Marnie Vinall',
			org: 'The Age',
			data: '2023kgbpdcfrnmohiealqj',
			url: 'https://www.theage.com.au/sport/afl/this-is-his-year-our-experts-preview-the-afl-season-20230206-p5cibc.html',
		},
		{
			name: 'Sam McClure',
			org: 'The Age',
			data: '2023gbkdcprnhfmioaejql',
			url: 'https://www.theage.com.au/sport/afl/this-is-his-year-our-experts-preview-the-afl-season-20230206-p5cibc.html',
		},
		{
			name: 'Damian Barrett',
			org: 'AFL Media',
			data: '2023bgpckmdfnraioheqjl',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Gemma Bastiani',
			org: 'AFL Media',
			data: '2023bgkpfrdnchmieajqol',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Riley Beveridge',
			org: 'AFL Media',
			data: '2023kbgnpcrdfmihaqeolj',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Sarah Black',
			org: 'AFL Media',
			data: '2023gkbpnrfdcmiheaoqlj',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Nat Edwards',
			org: 'AFL Media',
			data: '2023bkgpncrfmdhaiqeolj',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Josh Gabelich',
			org: 'AFL Media',
			data: '2023kbgcnrpdmfhiaoejql',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Sarah Olle',
			org: 'AFL Media',
			data: '2023gkbncprdihfmaoeqlj',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Nathan Schmook',
			org: 'AFL Media',
			data: '2023kbgpfcrndahmiqeolj',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Callum Twomey',
			org: 'AFL Media',
			data: '2023kbndgcmrpfhiaeolqj',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Michael Whiting',
			org: 'AFL Media',
			data: '2023gbkprchdfmnaqioejl',
			url: 'https://www.afl.com.au/news/881017',
		},
		{
			name: 'Squiggle',
			org: 'squiggle.com.au',
			data: '2023gkbpdcrnfomhiajeql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'Matter of Stats',
			org: 'matterofstats.com',
			data: '2023gnmdkpbrcfhoiajeql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'FMI',
			org: 'footymaths.blogspot.com',
			data: '2023gndmkprbfchoiajeql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'plusSixOne',
			org: 'plussixoneblog.com',
			data: '2023gkpbnrfmdcohjieaql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'Live Ladders',
			org: 'liveladders.com',
			data: '2023gnkpbdmcrfohiejaql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'AFLalytics',
			org: 'aflalytics.com',
			data: '2023gkpnmbrdfcohiajeql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'AFL Lab',
			org: 'theafllab.wordpress.com',
			data: '2023gknmbprcdfohaejiql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'Glicko Ratings',
			org: 'aflglickoratings.blogspot.com',
			data: '2023gknbcrpdmfahoeijql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'ZaphBot',
			org: 'zaphbot.blogspot.com',
			data: '2023gkmnfpcbhdrojeaiql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'Wheelo Ratings',
			org: 'wheeloratings.com',
			data: '2023gknbprmdcfohiajeql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'The Footycast',
			org: 'thefootycast.com',
			data: '2023gkpnbmfrdchoeijaql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'Elo Predicts!',
			org: 'elopredicts.blogspot.com',
			data: '2023kgpnbfmrdcohiejaql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'Graft Ratings',
			org: 'graftratings.com',
			data: '2023gkbpnmfrcodhjieaql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'Stattraction',
			org: 'stattraction.wordpress.com',
			data: '2023gkbpnrmfcdohejiaql',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2023',
			type: 'model',
		},
		{
			name: 'Tim Miller',
			org: 'The Roar',
			data: '2023kgbnpcrafhdmoqielj',
			url: 'https://www.theroar.com.au/2023/03/07/afl-oracle-someone-always-surges-into-september-from-the-bottom-five-so-who-will-it-be-in-2023/',
		},
		{
			name: 'Jonathan Horn',
			org: 'The Guardian',
			data: '2023dkgbnpmrfciahoeqjl',
			url: 'https://www.theguardian.com/sport/2023/mar/14/afl-2023-predicted-ladder-collingwood-hit-summit-but-flag-is-anyones-to-claim',
		},
		{
			name: 'Cody Atkinson & Sean Lawson',
			org: 'ABC',
			data: '2023kgnbpcmfrodhejaiql',
			url: 'https://www.abc.net.au/news/2023-03-16/afl-team-predicted-finish-2023/102096574',
			type: 'model',
		},
	],
	2022: [
		{
			name: '2021',
			org: 'Previous year\'s ladder',
			data: '2022kmgbrpieqofncjahdl',
			url: 'https://afltables.com/afl/seas/2021.html',
			type: 'history',
		},
		{
			name: '2021 + Finals',
			org: 'Standings after finals',
			data: '2022krmgbipeqofncjahdl',
			url: 'https://afltables.com/afl/seas/2021.html',
			type: 'history',
		},
		{
			name: 'Squiggle',
			org: 'squiggle.com.au',
			data: '2022krbpngmeoicqfdahjl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'Matter of Stats',
			org: 'matterofstats.com',
			data: '2022krpbgmeoinjaqfdchl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'FMI',
			org: 'footymaths.blogspot.com',
			data: '2022kbgmrpinoeqjdcflha',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'plusSixOne',
			org: 'plussixoneblog.com',
			data: '2022krmgbpneqiodcfjhal',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'Live Ladders',
			org: 'liveladders.com',
			data: '2022krmgbpneqiodcfjhal',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'AFLalytics',
			org: 'aflalytics.com',
			data: '2022kbrpgmeoinqjfdachl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'AFL Lab',
			org: 'theafllab.wordpress.com',
			data: '2022kbmrgnpeocqiadjfhl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'Glicko Ratings',
			org: 'aflglickoratings.blogspot.com',
			data: '2022kmgrpiboenjfqhcadl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'ZaphBot',
			org: 'zaphbot.blogspot.com',
			data: '2022kbpgrmeiojndcqaflh',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'The Cruncher',
			org: 'thecruncherau.vercel.app',
			data: '2022krgmpbeinofqcjadhl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'Wheelo Ratings',
			org: 'wheeloratings.com',
			data: '2022kbprmgeinojqadfchl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'The Footycast',
			org: 'thefootycast.com',
			data: '2022krbmgpoeinjqcdfahl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'Elo Predicts!',
			org: 'elopredicts.blogspot.com',
			data: '2022krbmgpoineqjfdchal',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2022',
			type: 'model',
		},
		{
			name: 'Pete Roberts',
			org: 'behindthefooty.com.au',
			data: '2022bkrpmgencfiodqjlha',
			url: 'https://www.behindthefooty.com.au/post/round-1-preview-2022',
		},
		{
			name: 'Tom Morris',
			org: 'Fox Sports',
			data: '2022bknmprecgiofahjldq',
			url: 'https://www.foxsports.com.au/afl/afl-news-2022-tom-morris-predicted-ladder-every-club-ranked-analysis-season-preview-top-eight-finals/news-story/e8fe4d752022dac6cbda2e348c4ddf98',
		},
		{
			name: 'Adrian Polykandrites',
			org: 'The Roar',
			data: '2022bkrmcgnipoefdlaqhj',
			url: 'https://fromthetopdeck.com.au/f/predicting-the-unpredictable',
		},
		{
			name: 'Max Laughton',
			org: 'Fox Sports',
			data: '2022kbnrgmcepoifhqdjal',
			url: 'https://www.foxsports.com.au/afl/afl-news-2022-season-preview-predicted-ladder-stats-analysis-rules-for-picking-top-eight-historic-results-who-misses-finals/news-story/a783b15321ac83793b7b2798ec212cd2',
		},
		{
			name: 'Chip',
			org: 'The Roar',
			data: '2022rkbnimgecopqdfjhal',
			url: 'https://www.theroar.com.au/2022/03/15/my-bold-predictions-for-the-2022-afl-ladder/',
		},
		{
			name: 'Jake Niall',
			org: 'The Age',
			data: '2022kbnrigcpfmeohjdqal',
			url: 'https://www.theage.com.au/sport/afl/afl-season-preview-dees-tipped-for-another-flag-but-don-t-discount-the-tigers-20220310-p5a3e3.html',
		},
		{
			name: 'Michael Gleeson',
			org: 'The Age',
			data: '2022knirbmgpcefhodqajl',
			url: 'https://www.theage.com.au/sport/afl/afl-season-preview-dees-tipped-for-another-flag-but-don-t-discount-the-tigers-20220310-p5a3e3.html',
		},
		{
			name: 'Peter Ryan',
			org: 'The Age',
			data: '2022krngpfbcmioedhqlaj',
			url: 'https://www.theage.com.au/sport/afl/afl-season-preview-dees-tipped-for-another-flag-but-don-t-discount-the-tigers-20220310-p5a3e3.html',
		},
		{
			name: 'Jon Pierik',
			org: 'The Age',
			data: '2022rkbnpgecmifoqdjlha',
			url: 'https://www.theage.com.au/sport/afl/afl-season-preview-dees-tipped-for-another-flag-but-don-t-discount-the-tigers-20220310-p5a3e3.html',
		},
		{
			name: 'Andrew Wu',
			org: 'The Age',
			data: '2022bkripcmengfohdqajl',
			url: 'https://www.theage.com.au/sport/afl/afl-season-preview-dees-tipped-for-another-flag-but-don-t-discount-the-tigers-20220310-p5a3e3.html',
		},
		{
			name: 'Greg Baum',
			org: 'The Age',
			data: '2022kbrgmefcnpioqldahj',
			url: 'https://www.theage.com.au/sport/afl/afl-season-preview-dees-tipped-for-another-flag-but-don-t-discount-the-tigers-20220310-p5a3e3.html',
		},
		{
			name: 'Sam McClure',
			org: 'The Age',
			data: '2022krgimbenpfcojdqahl',
			url: 'https://www.theage.com.au/sport/afl/afl-season-preview-dees-tipped-for-another-flag-but-don-t-discount-the-tigers-20220310-p5a3e3.html',
		},
		{
			name: 'Campbell Brown',
			org: '7news',
			data: '2022bkmrnegipcfoqdjhal',
			url: 'https://7news.com.au/sport/afl/campbell-brown-predicts-the-top-eight-teams-of-the-2022-afl-season-c-6048034',
		},
		{
			name: 'Damian Barrett',
			org: 'AFL Media',
			data: '2022bgkmnpcrifedjoqhal',
			url: 'https://www.afl.com.au/news/717215/crystal-ball-our-predictions-for-the-2022-afl-season-are-in',
		},
		{
			name: 'Riley Beveridge',
			org: 'AFL Media',
			data: '2022kbrnmpgcfeiohdlaqj',
			url: 'https://www.afl.com.au/news/717215/crystal-ball-our-predictions-for-the-2022-afl-season-are-in',
		},
		{
			name: 'Sarah Black',
			org: 'AFL Media',
			data: '2022rkmbpgniefqolcdahj',
			url: 'https://www.afl.com.au/news/717215/crystal-ball-our-predictions-for-the-2022-afl-season-are-in',
		},
		{
			name: 'Nat Edwards',
			org: 'AFL Media',
			data: '2022bkmrgnpcehfioqadlj',
			url: 'https://www.afl.com.au/news/717215/crystal-ball-our-predictions-for-the-2022-afl-season-are-in',
		},
		{
			name: 'Josh Gabelich',
			org: 'AFL Media',
			data: '2022bkngrmiecpfohqdjal',
			url: 'https://www.afl.com.au/news/717215/crystal-ball-our-predictions-for-the-2022-afl-season-are-in',
		},
		{
			name: 'Sarah Olle',
			org: 'AFL Media',
			data: '2022krbnmpgfiecoqhldja',
			url: 'https://www.afl.com.au/news/717215/crystal-ball-our-predictions-for-the-2022-afl-season-are-in',
		},
		{
			name: 'Nathan Schmook',
			org: 'AFL Media',
			data: '2022kbrminfgpeqcodaljh',
			url: 'https://www.afl.com.au/news/717215/crystal-ball-our-predictions-for-the-2022-afl-season-are-in',
		},
		{
			name: 'Callum Twomey',
			org: 'AFL Media',
			data: '2022kmrnbcifpeghodqalj',
			url: 'https://www.afl.com.au/news/717215/crystal-ball-our-predictions-for-the-2022-afl-season-are-in',
		},
		{
			name: 'Michael Whiting',
			org: 'AFL Media',
			data: '2022bkrpnmcighoefdqlaj',
			url: 'https://www.afl.com.au/news/717215/crystal-ball-our-predictions-for-the-2022-afl-season-are-in',
		},
		{
			name: 'Jake Michaels',
			org: 'ESPN',
			data: '2022kmrbgpneqoifcdjalh',
			url: 'https://www.espn.com.au/afl/story/_/id/32200015/afl-2022-espn-way-too-early-predictions-next-footy-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Matt Walsh',
			org: 'ESPN',
			data: '2022mkgbrfeopcnihaqldj',
			url: 'https://www.espn.com.au/afl/story/_/id/32200015/afl-2022-espn-way-too-early-predictions-next-footy-season-premier-runner-brownlow-medal',
		},
		{
			name: 'Jarryd Barca',
			org: 'ESPN',
			data: '2022kbrmngecopfihqdlaj',
			url: 'https://www.espn.com.au/afl/story/_/id/32200015/afl-2022-espn-way-too-early-predictions-next-footy-season-premier-runner-brownlow-medal',
		},
		{
			name: 'The Age readers',
			org: 'Reader survey',
			data: '2022kbrnmgpeciofdjhqla',
			url: 'https://www.theage.com.au/sport/afl/age-readers-at-odds-with-experts-on-blues-finals-chances-20220314-p5a4dg.html',
			type: 'crowd',
		},
		{
			name: 'Cody Atkinson & Sean Lawson',
			org: 'ABC',
			data: '2022rbkgpmeincqojdafhl',
			url: 'https://www.abc.net.au/news/2022-03-16/afl-2022-questions-to-be-answered-as-season-gets-underway/100911130',
			type: 'model',
		},
		{
			name: 'The Flag',
			org: 'theflagsports.wordpress.com',
			data: '2022kbpmrgonieqjfdclah',
			url: 'https://theflagsports.wordpress.com/2022/03/16/aflm-predictions-round-1-2022/',
			type: 'model',
		},
		{
			name: 'Stattraction',
			org: 'stattraction.wordpress.com',
			data: '2022kbrmgpneoiqjdfcahl',
			url: 'https://stattraction.wordpress.com/2022/03/14/tips-ratings-predictions-fixture-difficulty-pre-season-2022/',
			type: 'model',
		},
		{
			name: 'Daniel Cherny',
			org: 'CodeSports',
			data: '2022kbrcmgpfioehndqalj',
			url: 'https://twitter.com/DanielCherny/status/1561524103856951297',
		},
	],
	2021: [
		{
			name: '2020',
			org: 'Previous year\'s ladder',
			data: '2021mbngqordkicfehjpla',
			url: 'https://afltables.com/afl/seas/2020.html',
			type: 'history',
		},
		{
			name: '2020 + Finals',
			org: 'Standings after finals',
			data: '2021ngmbodqrkicfehjpla',
			url: 'https://afltables.com/afl/seas/2020.html',
			type: 'history',
		},
		{
			name: 'Adrian Polykandrites',
			org: 'The Roar',
			data: '2021gqmnrbiokfdhcpjlae',
			url: 'https://www.theroar.com.au/2021/03/15/getting-back-to-normal-whatever-that-is/',
		},
		{
			name: 'Connar Olsen',
			org: 'The Roar',
			data: '2021gbmqnokcrfdijhalep',
			url: 'https://www.theroar.com.au/2021/01/02/my-predictions-for-the-2021-afl-season/',
		},
		{
			name: 'Damien Barrett',
			org: 'AFL Media',
			data: '2021mbngqprodfckheiajl',
			url: 'https://www.afl.com.au/news/560486',
		},
		{
			name: 'Riley Beveridge',
			org: 'AFL Media',
			data: '2021mgnrboqdckifephjla',
			url: 'https://www.afl.com.au/news/560486',
		},
		{
			name: 'Sarah Black',
			org: 'AFL Media',
			data: '2021mngbrqdokfiecjhpal',
			url: 'https://www.afl.com.au/news/560486',
		},
		{
			name: 'Mitch Cleary',
			org: 'AFL Media',
			data: '2021mbngorqdcihfkejapl',
			url: 'https://www.afl.com.au/news/560486',
		},
		{
			name: 'Cameron Noakes',
			org: 'AFL Media',
			data: '2021bgmnrfqkdiochpejal',
			url: 'https://www.afl.com.au/news/560486',
		},
		{
			name: 'Nathan Schmook',
			org: 'AFL Media',
			data: '2021nmgqbrofichkdpeajl',
			url: 'https://www.afl.com.au/news/560486',
		},
		{
			name: 'Callum Twomey',
			org: 'AFL Media',
			data: '2021mgnrqcdbkohfipealj',
			url: 'https://www.afl.com.au/news/560486',
		},
		{
			name: 'Michael Whiting',
			org: 'AFL Media',
			data: '2021gbmnrqoidhkcpfejal',
			url: 'https://www.afl.com.au/news/560486',
		},
		{
			name: 'Benjamin Millard',
			org: 'Zero Hanger',
			data: '2021bnmgoqrkchdifjplea',
			url: 'https://www.zerohanger.com/way-too-early-2021-afl-ladder-predictions-news-80384/',
		},
		{
			name: 'Niall Seewang',
			org: 'ESPN',
			data: '2021gqnmbrokdfcpihjeal',
			url: 'https://www.espn.com.au/afl/story/_/id/30057739/afl-2021-our-way-too-early-predictions',
		},
		{
			name: 'Jake Michaels',
			org: 'ESPN',
			data: '2021gqnbmrdokcifpjeahl',
			url: 'https://www.espn.com.au/afl/story/_/id/30057739/afl-2021-our-way-too-early-predictions',
		},
		{
			name: 'Matt Walsh',
			org: 'ESPN',
			data: '2021nqbmgrckdoifhjepal',
			url: 'https://www.espn.com.au/afl/story/_/id/30057739/afl-2021-our-way-too-early-predictions',
		},
		{
			name: 'Rohan Connolly',
			org: 'Footyology',
			data: '2021nrgqmobpdfiekcjhla',
			url: 'https://www.statsinsider.com.au/blog/afl/the-afls-re-designed-obstacle-course-makes-for-a-wide-open-premiership-race',
		},
		{
			name: 'Stats Insider',
			org: 'statsinsider.com.au',
			data: '2021gnrmbcokqdpfjehila',
			url: 'https://www.statsinsider.com.au/afl/futures',
			type: 'model',
		},
		{
			name: 'Squiggle',
			org: 'squiggle.com.au',
			data: '2021gnrmokqbcdipfjehal',
			url: 'https://squiggle.com.au/ladder-prediction-2021/',
			type: 'model',
		},
		{
			name: 'Matter of Stats',
			org: 'matterofstats.com',
			data: '2021gnmbrodqkicfjpheal',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'Footy Maths Institute',
			org: 'footymaths.blogspot.com',
			data: '2021ngmrobqdkpfcjieahl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'PlusSixOne',
			org: 'plussixoneblog.com',
			data: '2021gmnqdbrikojpfeclha',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'Graft Ratings',
			org: 'graftratings.com',
			data: '2021mgnbqokdrifchjpela',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'Stattraction',
			org: 'stattraction.wordpress.com',
			data: '2021gnmqbirdjokcpflhea',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'Live Ladders',
			org: 'liveladders.com',
			data: '2021nbgrmoqfckidjpeahl',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'AFLalytics',
			org: 'aflalytics.com',
			data: '2021gnmbrqdokifcjphael',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'AFL Lab',
			org: 'theafllab.com',
			data: '2021bngqmrkcodjefphail',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'Glicko Ratings',
			org: 'aflglickoratings.blogspot.com',
			data: '2021ngbmrdqokcifepajlh',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'ZaphBot',
			org: 'zaphbot.blogspot.com',
			data: '2021ngmqrdbkocipjfehla',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2021',
			type: 'model',
		},
		{
			name: 'Cody Atkinson & Sean Lawson',
			org: 'ABC',
			data: '2021gnmqrobkdijcfpehla',
			url: 'https://www.abc.net.au/news/2021-03-18/will-afl-surprise-or-will-tigers-triumph-again/100014704',
			type: 'model',
		},
		{
			name: 'The Flag',
			org: 'theflagsports.wordpress.com',
			data: '2021mgnbkqrdofichpejla',
			url: 'https://theflagsports.wordpress.com/2021/03/18/aflm-predictions-round-1-2021/',
			type: 'model',
		},
		{
			name: 'Footy Forecaster',
			org: 'footyforecaster.com',
			data: '2021ngrmoqbkdpcfjiehal',
			url: 'https://footyforecaster.com/AFL/SeasonForecast',
			type: 'model',
		},
		{
			name: 'Jake Niall',
			org: 'The Age',
			data: '2021nmgbrqfodckipehjal',
			url: 'https://www.theage.com.au/sport/afl/can-the-blues-make-the-eight-only-one-expert-thinks-so-20210309-p57938.html',
		},
		{
			name: 'Michael Gleeson',
			org: 'The Age',
			data: '2021nmgrbqodkfichepjal',
			url: 'https://www.theage.com.au/sport/afl/can-the-blues-make-the-eight-only-one-expert-thinks-so-20210309-p57938.html',
		},
		{
			name: 'Peter Ryan',
			org: 'The Age',
			data: '2021mgnbrqkdofecjiphla',
			url: 'https://www.theage.com.au/sport/afl/can-the-blues-make-the-eight-only-one-expert-thinks-so-20210309-p57938.html',
		},
		{
			name: 'Jon Pierik',
			org: 'The Age',
			data: '2021grmnboqcdkifjehlap',
			url: 'https://www.theage.com.au/sport/afl/can-the-blues-make-the-eight-only-one-expert-thinks-so-20210309-p57938.html',
		},
		{
			name: 'Daniel Cherny',
			org: 'The Age',
			data: '2021gnmibrkoqcfdhpejal',
			url: 'https://www.theage.com.au/sport/afl/can-the-blues-make-the-eight-only-one-expert-thinks-so-20210309-p57938.html',
		},
		{
			name: 'Greg Baum',
			org: 'The Age',
			data: '2021gnmrbokqcdipfjheal',
			url: 'https://www.theage.com.au/sport/afl/can-the-blues-make-the-eight-only-one-expert-thinks-so-20210309-p57938.html',
		},
		{
			name: 'Sam McClure',
			org: 'The Age',
			data: '2021gbnmrodqfickhpjeal',
			url: 'https://www.theage.com.au/sport/afl/can-the-blues-make-the-eight-only-one-expert-thinks-so-20210309-p57938.html',
		},
		{
			name: 'Tom Morris',
			org: 'Fox Sports',
			data: '2021gmnobrkqcfedhipjal',
			url: 'https://www.foxsports.com.au/afl/afl-predictions-2021-tom-morris-full-ladder-1-to-18-every-club-analyses-collingwood-to-miss-finals-melbourne-makes-top-eight/news-story/2f2a8b8613aa9257d6773c026dab08b7',
		},
		{
			name: 'Max Laughton',
			org: 'Fox Sports',
			data: '2021ngmbroqkdfcihpjeal',
			url: 'https://www.foxsports.com.au/afl/afl-2021-power-rankings-preseason-afl-analysis-every-team-ranked-predicted-ladder-top-eight-finals-latest-news/news-story/953c81c20563ca270b6219fdc9890254',
		},
		{
			name: 'Campbell Brown',
			org: '7NEWS',
			data: '2021mgnqbrodhfckiepjal',
			url: 'https://7news.com.au/sport/afl/premiership-or-bust-for-one-afl-team-as-campbell-brown-drops-2021-predictions-c-2372410',
		},

	],

	2020: [
		{
			name: '2019',
			org: 'Previous year\'s ladder',
			data: '2020gbndqirejmalfopckh',
			url: 'https://afltables.com/afl/seas/2019.html',
			type: 'history',
		},
		{
			name: '2019 + Finals',
			org: 'Standings after finals',
			data: '2020nidgbqrejmalfopckh',
			url: 'https://afltables.com/afl/seas/2019.html',
			type: 'history',
		},
		{
			name: 'Niall Seewang',
			org: 'ESPN',
			url: 'https://www.espn.com.au/afl/story/_/id/27731256/afl-2020-our-way-too-early-predictions',
			data: '2020niqrdgjbkemcolpafh',
		},
		{
			name: 'Jake Michaels',
			org: 'ESPN',
			url: 'https://www.espn.com.au/afl/story/_/id/27731256/afl-2020-our-way-too-early-predictions',
			data: '2020nqdigbrjmkalecpfoh',
		},
		{
			name: 'Matt Walsh',
			org: 'ESPN',
			url: 'https://www.espn.com.au/afl/story/_/id/27731256/afl-2020-our-way-too-early-predictions',
			data: '2020nqdebirjgmlkcpaofh',
		},
		{
			name: 'Connar Olsen',
			org: 'The Roar',
			url: 'https://www.theroar.com.au/2020/01/02/predicting-the-2020-afl-season/',
			data: '2020ngiqdbjrlekfmpcaoh',
		},
		{
			name: 'Champion Data',
			org: '(* list strength ratings)',
			data: '2020nrdiqlgmebjokpafch',
			url: 'https://twitter.com/championdata/status/1226650566673063936',
			type: 'model',
		},
		{
			name: 'Giacomo Bruno',
			org: 'The Roar',
			url: 'https://www.theroar.com.au/2020/01/26/my-predictions-for-the-2020-afl-season/',
			data: '2020nqdgrbjiolekmcfhap',
		},
		{
			name: 'Stats Insider',
			org: 'statsinsider.com.au',
			data: '2020nrdiqlgmebjokpafch',
			url: 'https://www.statsinsider.com.au/afl/afl-2020-predictions-simulating-every-clubs-premiership-chances',
			type: 'model',
		},
		{
			name: 'HPN Footy (main)',
			org: 'ABC',
			data: '2020gndqjbimrlepakfoch',
			url: 'https://www.abc.net.au/news/2020-03-19/afl-2020-season-preview-geelong-richmond-collingwood-top-ladder/12066996',
			type: 'model',
		},
		{
			name: 'Brad Johnson',
			org: 'FOX Footy',
			url: 'https://twitter.com/FOXFOOTY/status/1240476839895633922/',
			data: '2020inbrqkdgealmpcjfoh',
		},
		{
			name: 'Campbell Brown',
			org: '7NEWS',
			url: 'https://7news.com.au/sport/afl/campbell-browns-shock-wooden-spoon-pick-in-2020-ladder-predictor-c-741531',
			data: '2020nqirbdojgefklmachp',
		},
		{
			name: 'The Roar readers',
			org: 'Fan survey',
			data: '2020ndqgibrjmelkocpafh',
			url: 'https://www.theroar.com.au/2020/03/15/meta-predictions-for-the-2020-afl-season/',
			type: 'crowd',
		},
		{
			name: 'Jake Niall',
			org: 'The Age',
			data: '2020iqnrdbjgmekpolfcah',
			url: 'https://www.theage.com.au/sport/afl/giants-eagles-tipped-to-rule-the-roost-in-unprecedented-afl-season-20200317-p54avb.html',
		},
		{
			name: 'Michael Gleeson',
			org: 'The Age',
			data: '2020qinrbdmgjokelapcfh',
			url: 'https://www.theage.com.au/sport/afl/giants-eagles-tipped-to-rule-the-roost-in-unprecedented-afl-season-20200317-p54avb.html',
		},
		{
			name: 'Peter Ryan',
			org: 'The Age',
			data: '2020inrqdgbmejkolcfpah',
			url: 'https://www.theage.com.au/sport/afl/giants-eagles-tipped-to-rule-the-roost-in-unprecedented-afl-season-20200317-p54avb.html',
		},
		{
			name: 'Jon Pierik',
			org: 'The Age',
			data: '2020qnbgirdmjkalecopfh',
			url: 'https://www.theage.com.au/sport/afl/giants-eagles-tipped-to-rule-the-roost-in-unprecedented-afl-season-20200317-p54avb.html',
		},
		{
			name: 'Daniel Cherny',
			org: 'The Age',
			data: '2020qnirogbdkjmelfpach',
			url: 'https://www.theage.com.au/sport/afl/giants-eagles-tipped-to-rule-the-roost-in-unprecedented-afl-season-20200317-p54avb.html',
		},
		{
			name: 'Greg Baum',
			org: 'The Age',
			data: '2020nqirbdgkejcpomaflh',
			url: 'https://www.theage.com.au/sport/afl/giants-eagles-tipped-to-rule-the-roost-in-unprecedented-afl-season-20200317-p54avb.html',
		},
		{
			name: 'Sam McClure',
			org: 'The Age',
			data: '2020iqnmrdbkgoejaclphf',
			url: 'https://www.theage.com.au/sport/afl/giants-eagles-tipped-to-rule-the-roost-in-unprecedented-afl-season-20200317-p54avb.html',
		},
		{
			name: 'Nick Dal Santo',
			org: 'FOX Sports',
			data: '2020nqbridgmeojlkcpfah',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Julian de Stoop',
			org: 'FOX Sports',
			data: '2020inqdrbgjmekolcpafh',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Ben Dixon',
			org: 'FOX Sports',
			data: '2020nrdqbimekjoglcpafh',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Max Laughton',
			org: 'FOX Sports',
			data: '2020ngrqjdbkimpleocafh',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Kath Loughnan',
			org: 'FOX Sports',
			data: '2020nirdqbgjmoelcpkfah',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Leigh Montagna',
			org: 'FOX Sports',
			data: '2020inrqdjbkgomefclpha',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Cameron Mooney',
			org: 'FOX Sports',
			data: '2020iknqdgbrjmpleaocfh',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Tom Morris',
			org: 'FOX Sports',
			data: '2020iqnjdrbmgoklcpefah',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Sarah Olle',
			org: 'FOX Sports',
			data: '2020nibrqdmgljkepocfha',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Ben Waterworth',
			org: 'FOX Sports',
			data: '2020ndirqbgmejlokcpfah',
			url: 'https://www.foxsports.com.au/afl/1-to-18-afl-experts-predict-the-full-2020-ladder-and-one-club-has-everyone-puzzled/news-story/f55fac2d80df0428546482e82543d805',
		},
		{
			name: 'Squiggle',
			org: 'squiggle.com.au',
			data: '2020nrgidmbjqfolpkecah',
			url: 'https://squiggle.com.au/ladder-prediction-2020/',
			type: 'model',
		},
		{
			name: 'AFL Lab',
			org: 'theafllab.com',
			data: '2020nrgbdqjpmliaefkcoh',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2020',
			type: 'model',
		},
		{
			name: 'Live Ladders',
			org: 'liveladders.com',
			data: '2020ngjbdprlimqkoaefch',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2020',
			type: 'model',
		},
		{
			name: 'The Arc',
			org: 'thearcfooty.com.au',
			// data: '2020nqkdgeiajmplrbofhc',
			data: '2020ngjdqrimlbpeafkcoh',
			// url: 'https://thearcfooty.com/2020-afl-ratings-and-projections/',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2020',
			type: 'model',
		},
		{
			name: 'HPN Footy (player model)',
			org: 'hpnfooty.com',
			data: '2020ngqdjeimkblropafch',
			url: 'https://www.hpnfooty.com/?p=32419',
			type: 'model',
		},
		{
			name: 'FMI',
			org: 'footymaths.blogspot.com',
			data: '2020njdgqrbmplicaeokfh',
			url: 'http://footymaths.blogspot.com/2020/03/2020-r1-ten-year-rule.html',
			type: 'model',
		},
		{
			name: 'Stattraction',
			org: 'stattraction.wordpress.com',
			data: '2020ngdqjbrlimpaefckoh',
			url: 'https://stattraction.wordpress.com/2020/03/18/predictions-before-round-1-2020/',
			type: 'model',
		},
		{
			name: 'PlusSixOne',
			org: 'plussixoneblog.com',
			data: '2020gndqmijapbrlefkoch',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2020',
			type: 'model',
		},
		{
			name: 'The Flag',
			org: 'theflagsports.wordpress.com',
			data: '2020ndqgbmjrilpeafckoh',
			url: 'https://theflagsports.wordpress.com/2020/03/19/aflm-predictions-round-1-2020/',
			type: 'model',
		},
		{
			name: 'AFLalytics',
			org: 'aflalytics.com',
			data: '2020ngjqbdrmlipaoekfch',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2020',
			type: 'model',
		},
		{
			name: 'Graft',
			org: 'graftratings.com',
			data: '2020gdrmbiqjnlpfaekoch',
			url: 'https://squiggle.com.au/ladder-scoreboard/?y=2020',
			type: 'model',
		},
		{
			name: 'Matter of Stats',
			org: 'matterofstats.com',
			data: '2020ngbrjmqdilapokfech',
			url: 'http://www.matterofstats.com/mafl-simulations/2020-simulating-the-final-ladder-preseason',
			type: 'model',
		},

		{
			name: 'Damien Barrett',
			org: 'AFL Media',
			data: '2020iqndgpbmrekjofaclh',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Riley Beveridge',
			org: 'AFL Media',
			data: '2020rqnibdgjomekclpafh',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Sarah Black',
			org: 'AFL Media',
			data: '2020dniqgbrkjefmlacpoh',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Jourdan Canil',
			org: 'AFL Media',
			data: '2020ngidqbrjmkeolafpch',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Mitch Cleary',
			org: 'AFL Media',
			data: '2020iqnrbdgjmokecafhlp',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Ben Collins',
			org: 'AFL Media',
			data: '2020iqdngrbkjolmefpach',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Adam Curley',
			org: 'AFL Media',
			data: '2020iqnrdkebomjgplhfca',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Nat Edwards',
			org: 'AFL Media',
			data: '2020qnibgdrkjoemlcpfah',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Lee Gaskin',
			org: 'AFL Media',
			data: '2020bndqimjkrglocpahef',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Marc McGowan',
			org: 'AFL Media',
			data: '2020nqirdbkgjomeclfaph',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Jennifer Phelan',
			org: 'AFL Media',
			data: '2020iqdnjkgrbolepfcmah',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Nathan Schmook',
			org: 'AFL Media',
			data: '2020nqridbjmgfolkecaph',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Callum Twomey',
			org: 'AFL Media',
			data: '2020qdibnmrkgejoacplhf',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
		{
			name: 'Michael Whiting',
			org: 'AFL Media',
			data: '2020inqrbdjkgmeolpcfha',
			url: 'https://www.afl.com.au/news/383687/crystal-ball-flag-tip-the-bolter-ladder-rising-star-more',
		},
	],
	2019: [
		{
			name: 'Damien Barrett',
			org: 'AFL Media',
			data: '2019aqnkdipfgeljmrbhco',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Paul Bastin',
			org: 'AFL Media',
			data: '2019ndakqigbelmjfproch',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Riley Beveridge',
			org: 'AFL Media',
			data: '2019kndqaiegjlrbpmfcoh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Sarah Black',
			org: 'AFL Media',
			data: '2019dnqkaijgeplfmbcroh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Mitch Cleary',
			org: 'AFL Media',
			data: '2019dnqkaigmjeplfbrcoh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Ben Collins',
			org: 'AFL Media',
			data: '2019ndkqiealgjpmfrobch',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Adam Curley',
			org: 'AFL Media',
			data: '2019ndqkieapmjrgflbcoh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Nat Edwards',
			org: 'AFL Media',
			data: '2019nqdkaigemjlpbrfcoh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Lee Gaskin',
			org: 'AFL Media',
			data: '2019ankiqdfemgpljbrcoh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Ben Guthrie',
			org: 'AFL Media',
			data: '2019nkqadgipemjrbfloch',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Travis King',
			org: 'AFL Media',
			data: '2019nkqdaeilgpbjfmrcoh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Marc McGowan',
			org: 'AFL Media',
			data: '2019nikqadegjmlfpbcroh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Dinny Navaratnam',
			org: 'AFL Media',
			data: '2019inqdkeaglpfmbjcroh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Callum Twomey',
			org: 'AFL Media',
			data: '2019ndqkaeipmgbjlrfoch',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'Michael Whiting',
			org: 'AFL Media',
			data: '2019nkqdaiepjbgmflrcoh',
			url: 'https://www.afl.com.au/news/2019-03-13/crystal-ball-aflcomaus-2019-season-predictions',
		},
		{
			name: 'AFL.com.au readers',
			org: 'Fan survey',
			data: '2019nqdakigejmplbfroch',
			url: 'https://www.afl.com.au/news/2019-03-18/your-season-predictions-premier-spoon-ladder-wholl-rise-and-fall',
			type: 'crowd',
		},
		{
			name: 'Jake Niall',
			org: 'The Age',
			data: '2019nqadikegjlmprbfcoh',
			url: 'https://www.theage.com.au/sport/afl/how-to-pick-your-2019-afl-ladder-20190317-p514zb.html',
		},
		{
			name: 'Michael Gleeson',
			org: 'The Age',
			data: '2019nqdkiaegpjmrblfcoh',
			url: 'https://www.theage.com.au/sport/afl/footy-in-2019-the-long-term-afl-forecast-20190309-p512yr.html',
		},
		{
			name: 'Peter Ryan',
			org: 'The Age',
			data: '2019qnadkjiegmrplbcfoh',
			url: 'https://www.theage.com.au/sport/afl/footy-in-2019-the-long-term-afl-forecast-20190309-p512yr.html',
		},
		{
			name: 'Jon Pierik',
			org: 'The Age',
			data: '2019qnkdaeilgjpmrbcfoh',
			url: 'https://www.theage.com.au/sport/afl/footy-in-2019-the-long-term-afl-forecast-20190309-p512yr.html',
		},
		{
			name: 'Daniel Cherny',
			org: 'The Age',
			data: '2019knqediapgljbcorhmf',
			url: 'https://www.theage.com.au/sport/afl/footy-in-2019-the-long-term-afl-forecast-20190309-p512yr.html',
		},
		{
			name: 'Greg Baum',
			org: 'The Age',
			data: '2019kaqndielgmrjbpcfho',
			url: 'https://www.theage.com.au/sport/afl/footy-in-2019-the-long-term-afl-forecast-20190309-p512yr.html',
		},
		{
			name: 'Sam McClure',
			org: 'The Age',
			data: '2019dnaqikelgbprjmocfh',
			url: 'https://www.theage.com.au/sport/afl/footy-in-2019-the-long-term-afl-forecast-20190309-p512yr.html',
		},
		{
			name: 'The Age readers',
			org: 'Fan survey',
			data: '2019nqdkaiegpjmlbrcfoh',
			url: 'https://www.theage.com.au/sport/afl/footy-in-2019-the-long-term-afl-forecast-20190309-p512yr.html',
			type: 'crowd',
		},
		{
			name: 'Tom Morris',
			org: 'Fox Sports',
			data: '2019qnkdaiejgpblfmocrh',
			url: 'https://www.foxsports.com.au/afl/afl-2019-collingwood-to-win-flag-says-foxsportscomau-senior-afl-reporter-tom-morris-in-his-predicted-ladder/news-story/e92d76e766820a9f9dfef712006c087c',
		},
		{
			name: 'Niall Seewang',
			org: 'ESPN',
			data: '2019ndkqeliaprjgbfmoch',
			url: 'https://www.espn.com.au/afl/story/_/id/25496154/afl-espn-2019-way-too-early-ladder-predictions-20',
		},
		{
			name: 'Jake Michaels',
			org: 'ESPN',
			data: '2019nkdqeiagpjmbrlfcoh',
			url: 'https://www.espn.com.au/afl/story/_/id/25496154/afl-espn-2019-way-too-early-ladder-predictions-20',
		},
		{
			name: 'Matt Walsh',
			org: 'ESPN',
			data: '2019nkqdeigajpmrblcfoh',
			url: 'https://www.espn.com.au/afl/story/_/id/25496154/afl-espn-2019-way-too-early-ladder-predictions-20',
		},
		{
			name: 'Nick Riewoldt',
			org: 'SEN',
			data: '2019nqakdgelipjbmfocrh',
			url: 'https://www.facebook.com/SEN1116/posts/nick-riewoldts-2019-afl-ladder-predictionmake-sure-to-download-the-brand-new-sen/2563123310371468/',
		},
		{
			name: 'Rohan Connolly',
			org: 'Footyology',
			data: '2019qnkadelgijpbmrfcoh',
			url: 'https://footyology.com.au/footyology-countdown-west-coast-our-tip-to-win-it/',
		},
		{
			name: 'Squiggle',
			org: 'squiggle.com.au',
			data: '2019nkiqgdaejmlborpfch',
			url: 'https://squiggle.com.au/its-2019/',
			type: 'model',
		},
		{
			name: 'AFL Lab',
			org: 'theafllab.com',
			data: '2019gnkqdiejalmbofprch',
			url: 'https://theafllab.com/2019/03/19/theres-no-2019-preview-why/',
			type: 'model',
		},
		{
			name: 'Live Ladders',
			org: 'liveladders.com',
			data: '2019nkgqiadjemlporbfch',
			url: 'https://twitter.com/AflLadder/status/1153912627476586496',
			type: 'model',
		},
		{
			name: 'The Arc',
			org: 'thearcfooty.com.au',
			data: '2019nqkdgeiajmplrbofhc',
			url: 'https://thearcfooty.com/2019-afl-ratings-and-projections/',
			type: 'model',
		},
		{
			name: 'HPN',
			org: 'hpnfooty.com',
			data: '2019ngkdqjieaplmbfroch',
			url: 'https://www.hpnfooty.com/?p=31509',
			type: 'model',
		},
		{
			name: 'FMI',
			org: 'footymaths.blogspot.com',
			data: '2019gkqnediajplmbrofhc',
			url: 'http://footymaths.blogspot.com/2019/03/2019-iteration-eight.html',
			type: 'model',
		},
		{
			name: 'Stattraction',
			org: 'stattraction.wordpress.com',
			data: '2019gknqdiepjamlbrofhc',
			url: 'https://stattraction.wordpress.com/2019/03/21/simulations-fixture-analysis-before-round-1-2019/',
			type: 'model',
		},
		{
			name: 'PlusSixOne',
			org: 'plussixoneblog.com',
			data: '2019gnqkpadmijlerofbhc',
			url: 'https://plussixoneblog.com/post/season-2019-aflm-preview-of-sorts/',
			type: 'model',
		},
		{
			name: 'Champion Data',
			org: '(* list strength ratings)',
			data: '2019kaendgiljbmqprocfh',
			url: 'https://www.zerohanger.com/champion-data-ranks-every-clubs-list-ahead-of-2019-season-26529/',
			type: 'model',
		},
		{
			name: 'Reddit r/AFL',
			org: 'Fan survey',
			data: '2019knaqdiegpjlbfmrohc',
			url: 'https://www.reddit.com/r/AFL/comments/aui68q/rafl_ladder_predictor_results/',
			type: 'crowd',
		},
		{
			name: 'Josh Elliot',
			org: 'The Roar',
			data: '2019aikqndebpgljomrfch',
			url: 'https://www.theroar.com.au/2019/03/20/the-roars-2019-afl-ladder-prediction-as-voted-by-you/',
		},
		{
			name: 'Adrian Polykandrites',
			org: 'The Roar',
			data: '2019nkadqgielbmjpfrcoh',
			url: 'https://www.theroar.com.au/2019/03/15/the-more-we-learn-the-less-we-know/',
		},

		{
			name: 'The Roar readers',
			org: 'Fan survey',
			data: '2019ndqkaiegpjmlbfrcoh',
			url: 'https://www.theroar.com.au/2019/03/20/the-roars-2019-afl-ladder-prediction-as-voted-by-you/',
			type: 'crowd',
		},
		{
			name: '2018',
			org: 'Previous year\'s ladder',
			data: '2019nqdjkpiglmearfbohc',
			url: 'https://afltables.com/afl/seas/2018.html',
			type: 'history',
		},
		{
			name: '2018 + Finals',
			org: 'Standings after finals',
			data: '2019qdnkjipglmearfbohc',
			url: 'https://afltables.com/afl/seas/2019.html',
			type: 'history',
		},
	],
}

class Experts extends Component {

	constructor(props) {
		super(props)

		Object.keys(experts).forEach( year => {
			experts[year].forEach( tip => {
				tip.order = tip.data.substr(4).split('').map(chr => chr.charCodeAt(0) - 96 )
			})
		})
	}

	render() {

		const { teams, year, standings } = this.props

		let content

		if (teams && year && experts.hasOwnProperty(year)) {

			experts[year].forEach(tip => {

				if (standings && standings.length) {
					tip.scores = computeScores(tip.order, teams, year)
				} else {
					tip.scores = {
						score: null,
						grade: 'TBD',
					}
				}
			})

			const sortedExperts = experts[year].sort((a, b) => b.scores.score - a.scores.score)

			let rank = 0
			sortedExperts.forEach((tip, index) => {
				const isEqualToPrev = index > 0 && tip.scores.score === sortedExperts[index - 1].scores.score
				if (!isEqualToPrev) {
					rank = index + 1
				}
				tip.rank = rank
				const isEqualToNext = index < sortedExperts.length - 1 && tip.scores.score === sortedExperts[index + 1].scores.score
				if (isEqualToPrev || isEqualToNext) {
					tip.isEqualRank = true
				}
			})

			content = sortedExperts.map((tip, index) =>
				<ExpertTip tip={tip} key={index} />
			)
		}

		return (
			<div>
				<p className="smalltext entry-summary">
					Collected ladders {year}. Click name to view analysis. If you know of a published expert ladder I've missed,
					please <a href="https://twitter.com/SquiggleAFL" target="_new">let me know!</a>
				</p>
				<table className="experts-leaderboard wrap-breakout">
					{content}
				</table>
				<p className="permalink-box">
					<a className="permalink" href={`?y=${year}`}>
						Back to Rate My Ladder
					</a>
				</p>
			</div>
		)
	}
}

class ExpertTip extends Component {
	render() {
		const { tip } = this.props

		let scoreHTML
		if (tip.scores.score === null) {
			scoreHTML = (
				<td className="main-score-lower">
					—
				</td>
			)
		} else {
			const digits = tip.scores.score.toFixed(1).split('.')
			scoreHTML = (
				<td className="main-score-lower">
					{digits[0]}
					<span className="number-suffix">
						.{digits[1]}
					</span>
				</td>
			)
		}

		let icon
		if (tip.type === 'model') {
			icon = <FiActivity />
		} else if (tip.type === 'crowd') {
			icon = <FiUsers />
		} else if (tip.type === 'history') {
			icon = <FiRewind />
		} else {
			icon = <FiUser />
		}
		return (
			<tr className="experts-row entry-summary">
				<td>
					{tip.isEqualRank && '='}
					{tip.rank}
				</td>
				{scoreHTML}
				<td>
					<div className={"grade gradecat-" + tip.scores.grade.substr(0, 1).toLowerCase()}>{tip.scores.grade}</div>
				</td>
				<td>
					{icon}
				</td>
				<td>
					<a href={"?q=" + tip.data}>
						{tip.name}
					</a>
				</td>
				<td>
					<a href={tip.url} target="_new">
						{tip.org}
					</a>
				</td>
			</tr>
		)
	}
}

export default Experts
